export default class LBODashboard {
  constructor({
    dealType = "STOCK",
    sharePriceType = "STOCK",
    transactionCostType = "AUTO",
    earnoutTarget = "Revenue",
    earnoutTargetAmount = 0,
    earnoutYears = 5,
    compensation = 0,
    consultingFee = 0,
    consultingPeriod = 60,
    interestRate = 0,
    amortizedOver = 0,
    gracePeriod = 0,
    balloonPaymentAfter = 90,
    cashSweepPortion = 0,
    exitYear = 10,
    longTermGrowthRate = 0,
    fixedSynergiesRate = 0,
    dividendsPercent = 0,
    capacity = 500000,
    SOFRCurrent = 0,
    SOFRStep = 0,
    PIKStep = 0,
    reinvestmentRate = 0,
    minimumCashBalance = 0,
    taxRate = 0,
    targetSharesOutstanding = 1,
    manualSharePrice = 0,
    stockPurchase = 0,
    assetPurchase = 0,
    fairMarketValue = 0,
    transactionCosts = 0,
    restructuringCharges = 0,
    premiumOrDiscount = 0,
    stockDebtAssumed = 0,
    assetDebtAssumed = 0,
    riskFreeRate = 0,
    equityRiskPremium = 0,
    sizePremium = 0,
    industryPremium = 0,
    countryRiskPremium = 0,
    companyRiskPremium = 0,
    summaryPercentPaid = 0,
  }) {
    this.dealType = dealType;
    this.sharePriceType = sharePriceType;
    this.transactionCostType = transactionCostType;
    this.earnoutTarget = earnoutTarget;
    this.earnoutTargetAmount = earnoutTargetAmount;
    this.earnoutYears = earnoutYears;
    this.compensation = compensation;
    this.consultingFee = consultingFee;
    this.consultingPeriod = consultingPeriod;
    this.interestRate = interestRate;
    this.amortizedOver = amortizedOver;
    this.gracePeriod = gracePeriod;
    this.balloonPaymentAfter = balloonPaymentAfter;
    this.cashSweepPortion = cashSweepPortion;
    this.exitYear = exitYear;
    this.longTermGrowthRate = longTermGrowthRate;
    this.fixedSynergiesRate = fixedSynergiesRate;
    this.dividendsPercent = dividendsPercent;
    this.capacity = capacity;
    this.SOFRCurrent = SOFRCurrent;
    this.SOFRStep = SOFRStep;
    this.PIKStep = PIKStep;
    this.reinvestmentRate = reinvestmentRate;
    this.minimumCashBalance = minimumCashBalance;
    this.taxRate = taxRate;
    this.targetSharesOutstanding = targetSharesOutstanding;
    this.manualSharePrice = manualSharePrice;
    this.stockPurchase = stockPurchase;
    this.assetPurchase = assetPurchase;
    this.fairMarketValue = fairMarketValue;
    this.transactionCosts = transactionCosts;
    this.restructuringCharges = restructuringCharges;
    this.premiumOrDiscount = premiumOrDiscount;
    this.stockDebtAssumed = stockDebtAssumed;
    this.assetDebtAssumed = assetDebtAssumed;
    this.riskFreeRate = riskFreeRate;
    this.equityRiskPremium = equityRiskPremium;
    this.sizePremium = sizePremium;
    this.industryPremium = industryPremium;
    this.countryRiskPremium = countryRiskPremium;
    this.companyRiskPremium = companyRiskPremium;
    this.summaryPercentPaid = summaryPercentPaid;
  }

  get earnoutTargetTotal() {
    return this.earnoutYears * this.compensation;
  }

  get consultingPaymentTotal() {
    return this.consultingFee * this.consultingPeriod;
  }

  get targetSharePrice() {
    const {
      sharePriceType,
      stockPurchase,
      assetPurchase,
      fairMarketValue,
      manualSharePrice,
      targetSharesOutstanding
    } = this;
    if(sharePriceType === "STOCK") return stockPurchase / targetSharesOutstanding;
    else if(sharePriceType === "ASSET") return assetPurchase / targetSharesOutstanding;
    else if(sharePriceType === "MARKETVALUE") return fairMarketValue / targetSharesOutstanding;
    else if(sharePriceType === "MANUAL") return manualSharePrice;
  }

  get offerPricePerShare() {
    return this.targetSharePrice * (1 + this.premiumOrDiscount / 100);
  }

  get purchasePrice() {
    return this.targetSharesOutstanding * this.offerPricePerShare;
  }

  get debtAssumed() {
    if(this.dealType === "STOCK") return this.stockDebtAssumed;
    else if(this.dealType === "ASSET") return this.assetDebtAssumed;
  }

  get balanceOfEquity() {
    return this.purchasePrice - this.debtAssumed;
  }

  get buildUpMethod() {
    return this.riskFreeRate +
      this.equityRiskPremium +
      this.sizePremium +
      this.industryPremium +
      this.countryRiskPremium +
      this.companyRiskPremium;
  }

  //deal offer summary items
  get summaryPurchasePrice() {
    if(this.dealType === "STOCK") return this.stockPurchase;
    else if(this.dealType === "ASSET") return this.assetPurchase;
  }

  get summaryBalanceOfEquity() {
    return this.summaryPurchasePrice - this.debtAssumed;
  }

  get summaryDownPayment() {
    return this.summaryBalanceOfEquity * this.summaryPercentPaid / 100;
  }

  get summaryFinancing() {
    return this.summaryBalanceOfEquity * (1 - this.summaryPercentPaid / 100);
  }
}
